import { useCallback } from 'react'
import SoundService from '../services/SoundService'

/**
 * Hook to use sound notifications
 * @returns {Object} Sound control methods
 */
const useSound = () => {
  /**
   * Play a sound based on type
   * @param {string} type - Type of sound ('success', 'info', 'warning', 'error', 'completion')
   */
  const playSound = useCallback((type) => {
    SoundService.play(type)
  }, [])

  /**
   * Play success sound
   */
  const playSuccess = useCallback(() => {
    SoundService.playSuccess()
  }, [])

  /**
   * Play info sound
   */
  const playInfo = useCallback(() => {
    SoundService.playInfo()
  }, [])

  /**
   * Play warning sound
   */
  const playWarning = useCallback(() => {
    SoundService.playWarning()
  }, [])

  /**
   * Play error sound
   */
  const playError = useCallback(() => {
    SoundService.playError()
  }, [])

  /**
   * Play completion sound
   */
  const playCompletion = useCallback(() => {
    SoundService.playCompletion()
  }, [])

  /**
   * Enable/disable sounds
   * @param {boolean} enabled
   */
  const setSoundEnabled = useCallback((enabled) => {
    SoundService.setEnabled(enabled)
  }, [])

  /**
   * Set volume
   * @param {number} volume - Volume level (0.0 to 1.0)
   */
  const setVolume = useCallback((volume) => {
    SoundService.setVolume(volume)
  }, [])

  /**
   * Check if sounds are enabled
   */
  const isSoundEnabled = useCallback(() => {
    return SoundService.isEnabled()
  }, [])

  return {
    playSound,
    playSuccess,
    playInfo,
    playWarning,
    playError,
    playCompletion,
    setSoundEnabled,
    setVolume,
    isSoundEnabled,
  }
}

export default useSound
